export enum Mode {
  VRI = 'VRI',
  VRS = 'VRS',
}
